import colors from '@magoosh/lib/styles/colors.module.scss';

export default (datumName: string, examName: string) => {
  if (examName === 'ACT') {
    return {
      'Math': colors.dataLightPurple,
      'Math Lessons': colors.dataLightPurple,
      'Math Questions': colors.dataDarkPurple,
      'English': colors.dataLightBlue,
      'English Lessons': colors.dataLightBlue,
      'English Questions': colors.dataDarkBlue,
      'Reading': colors.dataLightOrange,
      'Reading Lessons': colors.dataLightOrange,
      'Reading Questions': colors.dataDarkOrange,
      'Science': colors.dataLightGreen,
      'Science Lessons': colors.dataLightGreen,
      'Science Questions': colors.dataDarkGreen
    }[datumName];
  }
  else if (examName === 'GMAT') {
    return {
      'Math': colors.dataLightPurple,
      'Quant': colors.dataLightPurple,
      'Quantitative Reasoning': colors.dataLightPurple,
      'Quantitative Reasoning Lessons': colors.dataLightPurple,
      'Quantitative Reasoning Questions': colors.dataDarkPurple,
      'Verbal': colors.dataLightBlue,
      'Verbal Reasoning': colors.dataLightBlue,
      'Verbal Reasoning Lessons': colors.dataLightBlue,
      'Verbal Reasoning Questions': colors.dataDarkBlue,
      'Data': colors.dataLightOrange,
      'Data Insights': colors.dataLightOrange,
      'Data Insights Lessons': colors.dataLightOrange,
      'Data Insights Questions': colors.dataDarkOrange
    }[datumName];
  } else if (examName === 'GRE') {
    return {
      'Math': colors.dataLightPurple,
      'Math Lessons': colors.dataLightPurple,
      'Math Questions': colors.dataDarkPurple,
      'Vocab': colors.dataLightBlue,
      'Verbal': colors.dataLightBlue,
      'Verbal Lessons': colors.dataLightBlue,
      'Verbal Questions': colors.dataDarkBlue
    }[datumName];
  } else if (examName === 'SAT') {
    return {
      'Math': colors.dataLightPurple,
      'Math Lessons': colors.dataLightPurple,
      'Math Questions': colors.dataDarkPurple,
      'Reading & Writing': colors.dataLightBlue,
      'Reading & Writing Lessons': colors.dataLightBlue,
      'Reading & Writing Questions': colors.dataDarkBlue
    }[datumName];
  } else if (examName === 'TOEFL') {
    return {
      'Reading': colors.dataLightPurple,
      'Reading Lessons': colors.dataLightPurple,
      'Reading Questions': colors.dataDarkPurple,
      'Listening': colors.dataLightBlue,
      'Listening Lessons': colors.dataLightBlue,
      'Listening Questions': colors.dataDarkBlue,
      'Speaking': colors.dataLightOrange,
      'Speaking Lessons': colors.dataLightOrange,
      'Speaking Questions': colors.dataDarkOrange,
      'Writing': colors.dataLightGreen,
      'Writing Lessons': colors.dataLightGreen,
      'Writing Questions': colors.dataDarkGreen
    }[datumName];
  } else {
    return null;
  }
};
